const {APP_ROUTES, COUNTRIES} = require("./AppConstant");
const {genHash} = require("../utils/utils");

class App {
    constructor() {}

    static get ROUTES() {
        return APP_ROUTES
    };

    static genHash(length = 8){
        return genHash(length)
    }

    static get COUNTRIES() {
        return COUNTRIES
    };
}


exports = module.exports = App;